import React, { Component } from "react";

import "./styles.css";

export default class Error extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="PageContainer">
        <div className="VoteContainer">
          <h2 className="Votes__title">Ocorreu um erro ao votar!</h2>
          <h4 className="Votes__subtitle">Não foi possível registrar seu voto. Tente novamente.</h4>

          <a className="Button Vote-btn" href="/players">
            Tentar novamente
          </a>
        </div>
      </div>
    );
  }
}